import React from 'react';
import ReporteContenedoresBase from './ReporteContenedoresBase.jsx';

/**
 * V1: `IbuFront/src/components/views/Reportes/ReporteContenedoresCargos.jsx`.
 * Fuente: solo contenedores con `totalCargos > 0` en el rango de fechas (`GET
 * /contenedores/fechas-cargos/:inicio/:fin`, endpoint que ya existía en V2 —
 * `contenedores.service.js#listarPorFechasConCargos`, espejo exacto de
 * `ContenedoresController.findOneFechasCargos` de V1). V1 llegaba al mismo
 * resultado consultando `CargosContenedor` y agrupando por contenedor en el
 * cliente para deduplicar; V2 no lo necesita porque el backend ya regresa el
 * contenedor deduplicado directamente.
 */
export default function ReporteContenedoresCargosPage() {
  return <ReporteContenedoresBase endpoint="/cargos-contenedor/fechas" modo="cargos" title="Reporte Contenedores con Cargos" permiso="contenedores:reporte" />;
}
